import { SickDayEditModal } from '../pages/tma/SickDays'
import { HolidayEditModal } from '../pages/tma/Holidays'
import StaffEditModal from '../components/StaffEditModal'
import WarningModal from '../components/WarningModal'
import { ShiftEditModal } from '../components/ShiftEditModal'
import HolidayRequestModal from '../components/HolidayRequestModal'
import HolidayReviewModal from '../components/HolidayReviewModal'
import UpwModal from '../components/UpwModal'
import UserEditModal from '../components/UserManagement/UserEditModal'

const modals = {
  staffEditModal: StaffEditModal,
  sickDayEditModal: SickDayEditModal,
  holidayEditModal: HolidayEditModal,
  warningModal: WarningModal,
  shiftEditModal: ShiftEditModal,
  holidayRequestModal: HolidayRequestModal,
  holidayReviewModal: HolidayReviewModal,
  upwModal: UpwModal,
  userEditModal: UserEditModal
}

export default modals
